
import dealer from './dealer'

export default app => {
  return {
    ...dealer(app),
  }
}
